<template>
    <div class="ifree-information">
        <!--导航栏-->
        <Spin size="large" fix v-if="spinShow"></Spin>
        <navbar :transparent="isTransparent" activeTo="Home"></navbar>
        <div class="ifree-banner">
            <!-- Swiper -->
            <div class="swiper-container">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(item,index) in new_banner" :key="index">
                        <img :src="item.img" width="100%" @click="detail(item.cms_id)">
                        <p>{{item.title}}</p>
                    </div>
                </div>
                <!-- Add Pagination -->
                <div class="swiper-pagination"></div>
            </div>
        </div>
        <div class="new_list max_width" v-for="(item,index) in new_list" :key="index">
            <div class="new_list_item1">
                <a><img :src="item.img" @click="detail(item.cms_id)"></a>
            </div>
            <div class="new_list_item2">
                <h4 @click="detail(item.cms_id)"><a>{{item.title}}</a></h4>
                <p v-html="item.content"></p>
                <div>
                    <span>{{$t('consultation_date')}}:{{item.add_time}}</span>
                    <!--<span class="right">-->
                        <!--<img class="right1" src="../../assets/home/icon_like_normal@2x.png" width="16"> {{item.good}}-->
                    <!--</span>-->
                    <!--<span class="right" style="padding-right: 35px;">-->
                        <!--<img class="right2" src="../../assets/home/icon_look@2x.png" width="18"> {{item.read_number}}-->
                    <!--</span>-->
                </div>
            </div>
        </div>
        <div class="pages" style="margin: 10px;padding-left:4%;">
            <page :total="total" :length="limit" @on-change="refreshData"></page>
        </div>
        <BackTop>
            <div class="top">
                <img src="../../assets/backtop/top.png">
                <p style="">{{$t('top_btn')}}</p>
            </div>
        </BackTop>
        <a href="http://ifree.ly/support" target="_blank">
            <BackTop :height="100" :bottom="110">
                <div class="top">
                    <img src="../../assets/backtop/service.png">
                    <p>{{$t('Service_btn')}}</p>
                </div>
            </BackTop>
        </a>
    </div>
</template>

<script>
    import Signature from '../../lib/Signature'
    import Swiper from '../../../static/js/swiper-3.4.2.min'
    import navbar from '../Common/Navbar.vue'
    import page from '../Common/Page.vue'
    export default {
        data () {
            return {
                isTransparent:false,
                spinShow: true,
                new_banner:[],
                new_list:[],
                limit: 4,
                page: 1,
                total: 0
            }
        },
        components: {
            page,navbar
        },
        watch: {
            '$route': function (to, from) {
                this.fetchData()
            }
        },
        methods : {
            detail(id){
                this.$router.push({
                    name: 'ConsultationDetails',
                    query:  {
                        cms_id: id
                    }
                })
            },
            refreshData (page) {
                this.fetchData(page, this.limit)
            },
            fetchData (page, limit) {
                const module = 'index.php/cmslist'
                let data = {}
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                data.lang = this.$i18n.locale
                data.limit = this.limit
                data.page = page
                this.$http.get(process.env.BASEURL + module, {params: data})
                    .then(function (response) {
                        if (parseInt(response.data.code) === 2000) {
                            this.spinShow = false
                            console.log(response.data)
                            this.new_banner = response.data.data.banner
                            this.new_list = response.data.data.list
                            this.total = response.data.data.count
                        }
                    }.bind(this))
            }
        },
        mounted () {
            //获取新闻列表
            this.fetchData(this.page, this.limit)

            var swiper = new Swiper('.swiper-container', {
                pagination: '.swiper-pagination',
                paginationClickable: true,
                autoplay : 3000
            })
        }
    }
</script>
<style lang="scss">
    @import '../../assets/css/swiper-3.4.2.min.css';
    @import "../../scss/_information.scss";
</style>



// WEBPACK FOOTER //
// Information.vue?481b7810